module.exports = __webpack_public_path__ + "static/img/20200920.63ca501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/qiye/20200920/20200920.png
// module id = /63p
// module chunks = 1